import React, { useEffect, useState } from "react";
import sanityClient from "../client";
import { useMediaQuery } from "@uidotdev/usehooks";
import NavBarEN from "./NavBarEN";
import NavBarMobileEN from "./NavBarMobileEN";
import FooterEN from "./FooterEN";
import FormEN from "./FormEN";

export default function ReportEN() {
  const [reportData, setReportData] = useState([]);
  const isSmallDevice = useMediaQuery("only screen and (max-width: 768px)");
  const allDevices = useMediaQuery("only screen and (min-width: 769px)");

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "reportEN"] | order(_createdAt desc){
        _id,
        naslov,
        opis,
        link,
        dugme
      }`,
      )
      .then((data) => {
        console.log("SANITY EN DATA:", data);
        setReportData(data);
      })
      .catch(console.error);
  }, []);

  return (
    <>
      {allDevices && <NavBarEN />}
      {isSmallDevice && <NavBarMobileEN />}

      <main className="bg-white-100 min-h-screen p-12">
        <section className="container max-w-screen-xl mx-auto">
          <h1 className="text-4xl flex pb-8">Technical reports</h1>

          <section className="grid grid-cols-1 gap-4">
            {reportData.length > 0 ? (
              reportData.map((report) => (
                <article
                  className="relative pt-2 pb-4 border-b border-gray-200"
                  key={report._id}
                >
                  <h3 className="text-blue-600 text-2xl hover:text-blue-700">
                    {report.naslov}
                  </h3>

                  <p className="text-gray-700 py-4 dark:text-gray-400 mb-2">
                    {report.opis}
                  </p>

                  <a
                    href={report.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded"
                  >
                    {report.dugme}
                  </a>
                </article>
              ))
            ) : (
              <p className="text-gray-500 text-center">
                No reports available yet.
              </p>
            )}
          </section>
        </section>
      </main>

      <FormEN />
      <FooterEN />
    </>
  );
}
